// extracted by mini-css-extract-plugin
module.exports = {"cabecera":"Tabla_cabecera__3LZns","cabeceraContenedor":"Tabla_cabeceraContenedor__1zJpI"};